import './styles/chat.css'
import {AgentIcon, Robot, AddIcon} from "../../icons";
import {DialogIcon} from "../../icons";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, TextField, Tooltip} from '@mui/material';
import {currentTaskCacheProps, TaskStatusType} from "../../types/taskFlow.types";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {useCallback, useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import SendIcon from "@mui/icons-material/Send";
import {uploadLocalImage} from "../../api/common";
import {setSelectCanvasImage} from "../../store/taskSlice";
import uploadTips from "../../assets/uploadTips.png";
import CancelIcon from "@mui/icons-material/Cancel";
import {getLocalStorage} from "../../util/storage";
import {useTaskFlow} from "../../context/TaskFlowContext";
import {useSocketCommands} from "../../hooks/useSocketCommands";
import {setChatScreenPosition, setCurrentStepId, setScreenPosition} from "../../store/drawSlice";
import {useCanvasControl} from "../../hooks/useCanvasControl";
import chatNormal from "../../assets/chatNormal.svg"
import chatEnable from "../../assets/chatEnable.svg"
import { useTranslation } from 'react-i18next'

export default function HoverChatButton(props: {}) {

    const {loading, editor} = useTaskFlow()

    const dispatch = useDispatch();

    const { t } = useTranslation()

    return <div style={{
        position: 'fixed',
        willChange: 'transform',
        zIndex: 999,
    }} id='hover-chat-button'>
        <div style={{
            borderRadius: 8,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: 'pointer',
            padding: '20px 0 0 10px'
        }} onClick={(e) => {
            if (loading) return
            editor?.selectNone();
            const hoverChatButtonDom = document.getElementById('hover-chat-button');
            if (hoverChatButtonDom) {
                const stepId = hoverChatButtonDom.getAttribute('data-stepId');
                hoverChatButtonDom.style.display = 'none';
                dispatch(setCurrentStepId(stepId || ''))
            }
        }}>
{/*            <ChatBubbleOutlineIcon style={{fontSize: 20, marginTop: 3}}/>
            <div style={{fontSize: "14px"}}>Chat here</div>*/}
            <img src={loading ? chatEnable : chatNormal} alt=''/>
        </div>
    </div>;
}